var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderOne',{attrs:{"show-cart":_vm.showCart}}),_c('router-view'),_c('BottomPanel'),(_vm.isAppLoading)?_c('AppLoader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }